import LogoSlider from "../HomePage/LogoSlider";
import PressRoomBanner from "./PressRoomBanner"
import PressRoomTab from "./PressRoomTab";


function PressRoomPage() {
  return (
    <>
        <PressRoomBanner/>
        <PressRoomTab/>
        <section className="pt-0">
            <div className="container max-1330 mx-auto">
                <LogoSlider/>
            </div>
        </section>
        
    </>
  )
}

export default PressRoomPage;